export default {
      id: "sensors__rpm-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.svg#sensors__rpm",
      toString: function () {
        return this.url;
      }
    }